import throttle from 'lodash/throttle'

function optimize(type, name, obj) {
  obj = obj || window
  const func = throttle(function() {
    obj.dispatchEvent(new window.CustomEvent(name))
  }, 200)
  obj.addEventListener(type, func)
}

optimize('resize', 'optimizedResize')
